import request from '@/api/request.js'; //请求对象
 
 const apis = {
	
	delete (params){
		return request({url: `/admin_find_sound/delete`, method: 'POST', data:params})
	},
	read (params){
		return request({url: `/admin_find_sound/read`, params:params, method: 'GET'})
	},
	detail (params){
		return request({url: `/admin_find_sound/detail`, params:params, method: 'GET'})
	},
	answer (params){
		return request({url: `/admin_find_sound/answer`, params:params, method: 'POST'})
	},
	unreadStat (params){
		return request({url: `/admin_find_sound/unreadStat`, params:params, method: 'GET'})
	},
 }
 
 export default apis;
